const NUMBER_PATTERN = /^[-+]?(\d+(\.\d*)?|\.\d+)$/

/**
 * Whether a pivot filter operand reads as a plain decimal number — a sign, digits and one point, surrounding spaces
 * ignored. Exponent, hex and binary forms (`1e3`, `0x10`, `0b11`) are not numbers here, which `toNumber` would accept.
 */
export const isPivotNumericOperand = (value: string): boolean => NUMBER_PATTERN.test(value.trim())
